var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#A2A985"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5968 18.5937C15.3179 21.9087 18.067 24.6026 21.4487 26.2892L24.0707 23.7114C24.3995 23.3888 24.8682 23.2968 25.2804 23.4254C26.6118 23.8573 28.0482 24.0917 29.5312 24.0917C30.1922 24.0917 30.7227 24.6122 30.7227 25.2608V29.3519C30.7227 30.0005 30.1922 30.521 29.5312 30.521C18.3433 30.521 9.27734 21.6266 9.27734 10.6493C9.27734 10.0041 9.81127 9.48022 10.4689 9.48022H14.6387C15.2997 9.48022 15.8302 10.0007 15.8302 10.6493C15.8302 12.1043 16.0692 13.5141 16.5094 14.8223C16.6404 15.2243 16.5467 15.6875 16.2179 16.0101L13.5968 18.5942V18.5937Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.701d7a6ccd492544b69b9db2f155bf4e.svg";
export { ForwardRef as ReactComponent };